import { images } from '../constants';
import Carousel from './carousel';
import CustomLinkButton from './custom-link-button';
import { useTranslation } from 'react-i18next';

function About() {
    const { t } = useTranslation();

    const opinions = [
        {
            id: 1,
            fullName: "Chafaa Kherib",
            role: "Project Manager and Lead Q&A",
            opinion: "I had the pleasure of working with Ali Ameur on several projects, and I was consistently impressed by his contributions.  Beyond his strong technical skills, Ali is a true team player. He communicates effectively, collaborates seamlessly, and brings a positive and energetic attitude to every project.  His enthusiasm is contagious and helps propel the team forward, enabling us to achieve our goals more efficiently.",
            links: [{
                id: 1,
                link: 'https://www.linkedin.com/in/chafaa-kherib',
            }]
        },
        {
            id: 2,
            fullName: "Samy Outemzabet",
            role: "Back-End Lead Developer",
            opinion: "Working with Ali has been a real pleasure. He’s curious, determined, and always up for a challenge. He picks things up fast, doesn’t give up easily, and is constantly looking to improve. On top of that, he’s great to work with—reliable, motivated, and just the right amount of stubborn (in a good way!). His passion for growth and problem-solving truly stands out.",
            links: [{
                id: 1,
                link: 'https://www.linkedin.com/in/samy-outemzabet-232090213',
            },
            {
                id: 2,
                link: 'https://github.com/outemzabetsamy',
                path: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
                size: '30'
            }
            ]
         }
        // ,
        // {
        //     id: 3,
        //     fullName: "Ali Ameur",
        //     role: "Back-End Lead At Tesla",
        //     opinion: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        //     links: [{
        //         id: 1,
        //         link: 'https://linkedin.com',
        //     },
        //     {
        //         id: 2,
        //         link: 'https://github.com',
        //         path: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
        //         size: '30'
        //     },
        //     {
        //         id: 3,
        //         link: 'https://x.com',
        //         path: "M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z",
        //         size: '24'
        //     }
        //     ]
        // },
        // {
        //     id: 4,
        //     fullName: "Ali Ameur",
        //     role: "CEO and Founder of Black-Rock",
        //     opinion: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        //     links: [{
        //         id: 1,
        //         link: 'https://linkedin.com',
        //     },
        //     {
        //         id: 2,
        //         link: 'https://github.com',
        //         path: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
        //         size: '30'
        //     },
        //     {
        //         id: 3,
        //         link: 'https://x.com',
        //         path: "M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z",
        //         size: '24'
        //     }
        //     ]
        // }
    ];

    const buttons = [
        {
            id: 1,
            link: 'https://www.linkedin.com/in/ali-ameur-56b761299/'
        },
        {
            id: 2,
            link: 'https://www.youtube.com/@triangles-dev',
            path: "M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z",
            size: '24'
        },
        {
            id: 3,
            link: 'https://github.com/AliAmeur20',
            path: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
            size: '32'
        }
    ];

    return (
        <div className='bg-primary overflow-hidden'>
            <div className='container mx-auto'>
                <div className='flex flex-col lg:flex-row justify-center items-center lg:items-start text-primary-content py-20 md:py-28 gap-y-16'>
                    <div className='flex justify-center lg:justify-end w-full 2xl:w-1/3'>
                        <div className='lg:px-20 flex flex-col items-center'>
                            <img
                                alt='avatar'
                                src={images.ali}
                                className='w-72 h-72 rounded-full object-cover shadow-2xl'
                            />
                            <div className='flex text-primary-content gap-x-2 mt-6'>
                                {buttons.map((button, index) => (
                                    <CustomLinkButton
                                        key={index}
                                        style_classes={"custom-primary-btn"}
                                        size={button.size}
                                        link={button.link}
                                        path={button.path}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='px-5 lg:px-10 2xl:w-1/3'>
                        <div className='text-3xl font-bold'>
                            {t('about.greeting')}
                        </div>
                        <br />
                        <div className='text-lg font-medium'>
                            <p>
                                {t('about.p1')}
                            </p>
                            <br />
                            <p>
                                {t('about.p2')}
                            </p>
                            <br />
                            <p>
                                {t('about.p3')}
                            </p>
                            <br />
                            <p>
                                {t('about.p4')}
                            </p>
                        </div>
                    </div>
                </div>

                <div className='flex justify-end px-3 md:px-8 pb-12'>
                    <div className='flex justify-end'>
                        <Carousel elements={opinions} cardType="opinion" color='primary' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;